//高鐵選擇面板
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// TS type
import { TTripType, TStep } from '@redux/common';
// Redux
import { RootState } from '@redux/store';

// import module

// component
import THSRSearch from './THSRSearch';
import TrainBlock from './TrainBlock';

// svg component
import Alert from '@svg/Alert';
import SearchNone from '@svg/SearchNone';

// icon component
import LoadingIcon from '@svg/LoadingIcon';
import Loading from '@Common/loading';

// plugin
import dayjs from 'dayjs';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

// redux actions
import { setTHSROptsMOpen, setTCurrentStep } from '@redux/THSR/actions';

interface ITHSRPanelProps {
    THSRTripType?: string;
}

const THSRPanel: React.FC<ITHSRPanelProps> = (props) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const store_THSR = useSelector((state: RootState) => state.THSR);
    const searchPanelRef = useRef(null);
    const isDisableConfirm = () => {
        let disable = false;
        if (props.THSRTripType === TTripType.oneway) {
            if (!store_THSR.THSRDepartTrain || store_THSR.THSRDepartTrain == null) {
                disable = true;
            }
        }

        if (props.THSRTripType === TTripType.round) {
            if (
                !store_THSR.THSRDepartTrain ||
                store_THSR.THSRDepartTrain == null ||
                !store_THSR.THSRReturnTrain ||
                store_THSR.THSRReturnTrain == null
            ) {
                disable = true;
            } else {
                //出發日期+時間(抵達)
                /**
                    單用ArriveTime會有跨日問題
                    因此需算出Duration的時間（分鐘）加在departTime後
                */
                let Duration =
                    store_THSR.THSRDepartTrain.Duration.split('小時')[0] * 60 +
                    parseFloat(store_THSR.THSRDepartTrain.Duration.split('小時')[1]);
                let departTime =
                    store_THSR.THSRSearchOption.startDate +
                    ' ' +
                    store_THSR.THSRDepartTrain.DepartTime;
                departTime = dayjs(departTime).add(Duration, 'minute').format('YYYY-MM-DD HH:mm');
                //回程日期+時間(出發)
                const returnTime =
                    store_THSR.THSRSearchOption.endDate +
                    ' ' +
                    store_THSR.THSRReturnTrain.DepartTime;

                if (dayjs(departTime).isAfter(dayjs(returnTime))) {
                    //出發比回程晚
                    disable = true;
                }
            }
        }
        return disable;
    };

    const clickConfirm = () => {
        if (isDisableConfirm()) return false;
        dispatch(setTCurrentStep(1));
        dispatch(setTHSROptsMOpen(true));
    };

    //如果班次查詢失敗或call api的時候報錯的畫面
    const renderError = (errMsg) => {
        return (
            <div className="roundsContainer">
                <div className="roundsTitle">
                    <div className="errorContainer">
                        <div className="errorContent">
                            {errMsg === t('THSR.commonPanel.error') ? <Alert /> : <SearchNone />}
                            {errMsg !== 'NoBusinessClass' && <span>{errMsg}</span>}
                            {errMsg === 'NoBusinessClass' && (
                                <>
                                    <span>
                                        {t('THSR.commonPanel.youCanChangeSearch', {symbol: '：'})}
                                        <button
                                            onClick={() => {
                                                searchPanelRef?.current.researchByNormalClass();
                                            }}
                                        >
                                           {t('THSR.commonPanel.standardCarriage')}
                                        </button>
                                    </span>

                                    <br />
                                    <span>
                                        {t('THSR.commonPanel.NoBusinessClassForSaleMsg', {
                                            loc1: t('THSR.commonPanel.Nangang'),
                                            loc2: t('THSR.commonPanel.Taipei'),
                                            loc3: t('THSR.commonPanel.Banqiao'),
                                            loc4: t('THSR.commonPanel.Banqiao_localTrain')
                                        })}
                                    </span>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return store_THSR.THSRInitData && store_THSR.THSRStations ? 
    (
        <div
            className={cx('THSRPanel', {
                hide: store_THSR.TCurrentStep === TStep.second,
            })}
        >
            <THSRSearch ref={searchPanelRef} THSRTripType={props.THSRTripType} />
            {store_THSR.THSRDetailData && store_THSR.THSRInfo && (
                <div className="THSRResult">
                    <p className="subtitle">{t('THSR.commonPanel.choose_trainNumber', {particle: t('THSR.commonPanel.please')})}</p>
                    <div className="leftPart">
                        {!store_THSR.THSRDetailData?.error &&
                            !store_THSR.THSRInfo?.error &&
                            store_THSR.THSRDetailData?.Rounds &&
                            store_THSR?.THSRInfo &&
                            store_THSR.THSRDetailData?.Rounds.map((child, index) => {
                                return <TrainBlock data={child} tripDirection={index} />;
                            })}
                        {(store_THSR.THSRDetailData?.error || store_THSR.THSRInfo?.error) &&
                            renderError(
                                store_THSR.THSRDetailData?.error || store_THSR.THSRInfo?.error
                            )}
                    </div>
                    <div className="rightPart">
                        <div className="priceArea">
                            <div
                                className={cx('submitButton', {
                                    disabled: isDisableConfirm(),
                                })}
                                onClick={() => clickConfirm()}
                            >
                                <button>{t('THSR.commonPanel.chooseTrainComplete')}</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {(!store_THSR.THSRDetailData || !store_THSR.THSRInfo) && store_THSR.THSRDetailLoading && (
                <div className="THSRResult">
                    <div className="loadContainer">
                        <div className="loadBlock">
                            <Loading icon={<LoadingIcon />} text={t('THSR.commonPanel.loading_trainNumber')} />
                        </div>
                    </div>
                </div>
            )}
        </div>
    ) : (
        <Loading icon={<LoadingIcon />} />
    );
};

export default THSRPanel;